import { BreakpointObserver } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { Constants } from 'src/app/shared/constants';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { BroadcastService } from '../services/broadcast.service';
import { DialogService } from '../services/dialog.service';
import { ClindxTableFilterComponent } from '../clindx-table-filter/clindx-table-filter.component';
import { ChangeDetectorRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { isNullOrUndefined } from 'util';
import { LocalStorageService } from '../services/local-storage.service';
import { BusinessUnitDto } from 'src/app/core/interfaces/loggedInUserDto';
import { ResultsService } from 'src/app/feature/results/Service/results.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TestResultGraphRequest } from 'src/app/core/classes/test-result-graph-request';
import { GraphDialogComponent } from './graph-dialog/graph-dialog/graph-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GraphResulData } from 'src/app/core/classes/orderResult';
import { LoaderService } from '../loader/loader.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-clindx-mat2-table',
    templateUrl: './clindx-mat2-table.component.html',
    styleUrls: ['./clindx-mat2-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('detailExpand', [
          state('collapsed', style({ height: '0px', minHeight: '0' })),
          state('expanded', style({ height: '*' })),
          transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class ClindxMat2TableComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @Input() config: any;
  @Input() filterChipset: any;
  @Output() filterChipsetChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() dataSource: Subject<any>;
  @Input() SpecimenTableKeyPress: any;
  @Output() UpdateSpecimen: EventEmitter<any> = new EventEmitter<any>();
  @Output() DeleteSpecimen: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() sorted: EventEmitter<any> = new EventEmitter<any>();
  @Output() paginationChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() filterRemoved: EventEmitter<any> = new EventEmitter<any>();
  @Input() isAllSelected: boolean;
  @Output() isAllSelectedChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() filterConfig: any;
  @Input() pageSizeInput = 0;
  @Input() drawInNextNDays: number | null = null;
  @Input() soExpiringInNextNDays: number | null = null;
  isAltIpressed = false;
  @Output() isAltIpressedEmitter = new EventEmitter<boolean>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Input() KeyPressedStr: Subject<string>;
  isScreenSmall: Observable<boolean>;
  columnList = [];
  pageIndex = 0;
  length = 0;
  pageSize: number;
  pageSizeOptions: number[] = Constants.PAGINATION_PAGE_SIZE_OPTIONS;
  matDataSource: any;
  displayedColumns: any;
  panelDisplayColumns: any;
  runOnlyOnce = true;
  iconForSelectAll = 'playlist_add_check';
  iconForUnselectAll = 'clear';
  nestedColumns: any;
  nestedDisplayColumns: any;
  curentFocusingIndex = 0;
  tablesRows: any;
  testResults: TestResultGraphRequest = {
    mainAccountCode: '',
    parameterCode: '',
    testCode: '',
    patientGuid: ''
  };
  testDetails: GraphResulData = {
    results: [],
    mainAccountCode: '',
    mainAccountName: '',
    patientFirstName: '',
    patientLastName: '',
    patientDOB: new Date(),
    testName: '',
    parameterName: '',
    resultUnit: ''
  };
  includeArchivedOrders = false;
  isDrawInNextNDaysActive = false;
  isSoExpiringActive = false;
  includeStandingOrders = false;
  private businessUnits: BusinessUnitDto[];
  private broadcastSubscription: Subscription;
  private queryParamsSubscription: Subscription;

  @HostListener('window:resize')
  onWindowreSize() {
    if (!this.platform.TRIDENT && this.config.hasStickyHeader) {
      this.checkHasOverflow();
    }
  }

  @HostListener('window:beforeprint')
    onBeforePrint() {
    this.config.isResponsive = false;
    this.cdr.detectChanges();
  }

  constructor(
    private readonly platform: Platform, 
    private readonly elem: ElementRef,
    breakpoints: BreakpointObserver, 
    private readonly auth: AuthenticationService, 
    private readonly broadcastService: BroadcastService,
    private readonly dialogService: DialogService, 
    private readonly resultsService: ResultsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly localStorageService: LocalStorageService,
    private readonly dialog: MatDialog,
    private readonly loader: LoaderService,
    private readonly route: ActivatedRoute 
  ) {
    this.isScreenSmall = breakpoints.observe(`(max-width: ${Constants.SMALL_WIDTH_BREAKPOINT}px)`)
      .pipe(map(breakpoint => breakpoint.matches));
  }

  ngOnInit() {
    this.businessUnits = this.auth.GetLoggedInUserDetails().businessUnits;
    this.pageSize = this.pageSizeInput === 0 ? Constants.PAGINATION_PAGE_SIZE : this.pageSizeInput;
    if (this.config.sortState) {
      this.applyDefaultSort();
    }

    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      if (params.viewType === 'standing') {
        this.includeStandingOrders = true;
      } else {
        this.includeStandingOrders = false;
      }
    });

    this.dataSource.subscribe(results => {
      this.matDataSource = results;
      if (this.config.sortState &&
        this.config.sortState.sortType === 'CLIENT' &&
        this.runOnlyOnce) {
        this.sort.disableClear = true;
        this.matDataSource.sort = this.sort;
        this.matDataSource.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId] ? data[sortHeaderId].toLocaleLowerCase() : '';
        this.matDataSource.paginator = this.paginator;
        this.runOnlyOnce = false;
      }
     
      if (this.config.pagination && this.paginator) {
        this.paginator.length = results?.data?.length > 0 ? results?.data[0]?.totalCount : 0;
      }
    });

    if (this.config.pagination) {
      this.broadcastSubscription = this.broadcastService.subscribe().subscribe(message => {
        if (!this.paginator) {
          return;
        }

        // When filters change, start from first page but keep user-selected page size
        if (message.type === Constants.FILTER_EVENT || message.type === Constants.PAGINATION_RESET) {
          this.paginator.pageIndex = 0;
        }
      });
    }
 
    this.config.columnList = this.config.columnList.filter((col) => { if (!col.hidden && !col.includeInFilter) { return col.columnName; }});
    this.displayedColumns = this.config.columnList.map((col) => col.columnName);
    if (this.KeyPressedStr) {
      this.KeyPressedStr.subscribe(x => this.handleKeyPress(x));
    }
    this.dataSource.subscribe(s => this.tablesRows = s.data);
  }

  private handleKeyPress(x: string) {
    if (x === Constants.AltI) {
      this.isAltIpressed = true;
      this.isAltIpressedEmitter.emit(this.isAltIpressed);
      this.focusCurrentHighlightedSpecimenTableRowelement();
      this.curentFocusingIndex = 0;
    } else if (x === 'ArrowDown' && this.curentFocusingIndex < this.tablesRows.length - 1 && this.isAltIpressed) {
      this.curentFocusingIndex++;
      this.focusCurrentHighlightedSpecimenTableRowelement();
    } else if (x === 'ArrowUp' && this.curentFocusingIndex > 0 && this.isAltIpressed) {
      this.curentFocusingIndex--;
      this.focusCurrentHighlightedSpecimenTableRowelement();
    } else if (x === 'Delete' && this.isAltIpressed) {
      this.handleDelete();
    } else if (x === 'Update' && this.isAltIpressed) {
      if (this.tablesRows[this.curentFocusingIndex]) {
        this.UpdateSpecimen.emit(this.tablesRows[this.curentFocusingIndex]);
        this.isAltIpressed = false;
        this.isAltIpressedEmitter.emit(this.isAltIpressed);
      }
    } else if (x === 'reset' && this.isAltIpressed) {
      this.isAltIpressed = false;
      this.isAltIpressedEmitter.emit(this.isAltIpressed);
    }
  }

  private handleDelete() {
    if (this.tablesRows[this.curentFocusingIndex]) {
      this.DeleteSpecimen.emit(this.tablesRows[this.curentFocusingIndex]);
      if (this.curentFocusingIndex > 0) {
        this.curentFocusingIndex--;
      }
    }
  }

  focusCurrentHighlightedSpecimenTableRowelement() {
    const id = 'specimenRow' + this.curentFocusingIndex;
    document.getElementById(id).focus();
  }

  addColumnConditional(data) {
    const noValue = false;
    const displayColumns = (this.config.panelColumnList) ? this.config.panelColumnList.map((col) => col.columnName) : null;
    return (noValue) ? displayColumns.slice(0, -1) : displayColumns;
  }

  fetchTestDetails(element: any){
    let dialogRef: any;
    this.testResults.mainAccountCode = element['mainAccountCode'];
    this.testResults.parameterCode = element.parameterCode;
    this.testResults.testCode = element.testCode;
    this.testResults.patientGuid = element.patientGuid;
    this.loader.show();
    this.resultsService.getTestDetailsForGraph(this.testResults)
      .subscribe({
        next: (data: any[]) => {
           this.testDetails.results = data.map(result => ({
            collectionDate: result.collectionDate,
            resultValueWithUnit: `${result.resultValue + ' '} ${result.resultUnit}`,
          }));

          this.testDetails.mainAccountCode = this.testResults.mainAccountCode;
          this.testDetails.mainAccountName = element.mainAccountName;
          this.testDetails.patientFirstName = data[0].patientFirstName;
          this.testDetails.patientLastName = data[0].patientLastName;
          this.testDetails.patientDOB = data[0].patientDOB;
          this.testDetails.parameterName = data[0].parameterName;
          const firstNonEmptyResultUnit = data.find(item => item.resultUnit !== null && item.resultUnit !== '');
          this.testDetails.resultUnit = firstNonEmptyResultUnit ? firstNonEmptyResultUnit.resultUnit : '';
          this.testDetails.testName = element.testName;
          dialogRef = this.dialog.open(GraphDialogComponent, {
            data:  this.testDetails,// Pass your data here
            panelClass: 'graph-dialog-container',
          });
          this.loader.hide();
          dialogRef.afterClosed().subscribe(result => {
            // Handle any post-dialog logic here
          });
        }, error: (error: HttpErrorResponse) => {
        }
        });
       
  }

  convertString(input: string): string {
    if (input.includes('E') || input.includes('e')) {
        return Number(input).toString();
    }

    if (input.includes(',')) {
        return input.replace(/,/g, '');
    }
    return input;
  }

  ngAfterViewInit() {
    const elements = this.elem.nativeElement.querySelectorAll('.mat-paginator-page-size-label');
    if (elements && elements.length > 0) {
      elements.forEach((label: HTMLElement) => {
        label.innerText = 'Page Size:';
      });
    }
  }

  ngAfterViewChecked() {
    if (!this.platform.TRIDENT && this.config.hasStickyHeader) {
      this.checkHasOverflow();
    }
  }

  checkHasOverflow() {
    const tableOuterCollection = document.getElementsByClassName('clindx-table');
    const tableOuterCover = tableOuterCollection[(tableOuterCollection.length > 1) ?
      tableOuterCollection.length - 1 : 0];
    const innerTableCollection = document.getElementsByClassName('stickyTable');
    const innerTable = innerTableCollection[(innerTableCollection.length > 1) ?
      tableOuterCollection.length - 1 : 0];
    if (innerTable && innerTable.scrollWidth) {
       if (innerTable && tableOuterCover.clientWidth < innerTable.scrollWidth) {
          tableOuterCover.classList.add('addOverFlow');
        } else {
        tableOuterCover.classList.remove('addOverFlow');
      }
    }
  }

  selection() {
    this.isAllSelected = !this.isAllSelected;
    this.isAllSelectedChange.emit(this.isAllSelected);
  }

  sortData(event) {
    this.sorted.emit(event);
  }

  setPaginationObject() {
    this.paginationChanged.emit(this.paginator);
  }

  onPage(event: any) {
    // Preserve existing behaviour: only emit paginationChanged for
    // non-CLIENT sort grids (server-side pagination like CP Orders).
    if (!this.config?.sortState || this.config.sortState.sortType !== 'CLIENT') {
      this.setPaginationObject();
    }

    // Scroll grid back to top after page change
    setTimeout(() => {
      if (!this.elem?.nativeElement) {
        return;
      }

      // Primary scroll container for the grid is the bordered wrapper
      // which gets max-height + overflow:auto in the stylesheet.
      let scrollable = this.elem.nativeElement.querySelector('.mat-table-container--bordered');

      // Fallbacks in case layout differs on some screens
      if (!scrollable) {
        scrollable = this.elem.nativeElement.querySelector('.clindx-table');
      }

      // Case 1: grid has its own scrollbar (small/medium screens).
      // In this layout we reset the internal scroll only.
      if (scrollable && typeof scrollable.scrollTop === 'number' &&
          scrollable.scrollHeight > scrollable.clientHeight) {
        scrollable.scrollTop = 0;
        return;
      }

      // Case 2: no internal scrollbar (large screens). Scroll the
      // whole component into view in the window as before.
      if (typeof this.elem.nativeElement.scrollIntoView === 'function') {
        this.elem.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  }

  removeFilter(chip) {
    this.filterRemoved.emit(chip);
  }

  openFilterDialog() {
    if (this.filterConfig) {
      this.dialogService.OpenDialog(ClindxTableFilterComponent, this.filterConfig, this.config.columnList);
    } else {
      this.dialogService.filterDialog(this.config.columnList);
    }
  }

  isBuTgiorVcd(): boolean {
    return this.businessUnits.some(x => Constants.BUCODE_TGI_VCD.some(code => x.buCode.includes(code)));
  }

  isBuTgi(): boolean {
    return this.businessUnits.some(x => x.buCode.includes(Constants.BUCODE_TGI));
  }

  includeArchiveOrders(): void {
  if (!this.includeArchivedOrders) {
    this.includeArchivedOrders = true;
    this.getArchiveOrders();
  }
}

  excludeArchiveOrders(event: Event): void {
    event.stopPropagation();
    this.includeArchivedOrders = false;
    this.getArchiveOrders();
  }

  getArchiveOrders(): void {
    this.broadcastService.broadcast(Constants.INCLUDE_ARCHIVED_ORDERS, this.includeArchivedOrders);
  }

  activateDrawInNextNDays(): void {
    if (!this.isDrawInNextNDaysActive) {
      this.isDrawInNextNDaysActive = true;
      this.broadcastService.broadcast(Constants.DRAW_IN_NEXT_N_DAYS, this.drawInNextNDays);
    }
  }

  deactivateDrawInNextNDays(event?: Event): void {
    if (event) { event.stopPropagation(); }
    this.isDrawInNextNDaysActive = false;
    this.broadcastService.broadcast(Constants.DRAW_IN_NEXT_N_DAYS, null);
  }

  activateSoExpiring(): void {
    if (!this.isSoExpiringActive) {
      this.isSoExpiringActive = true;
      this.broadcastService.broadcast(Constants.SO_EXPIRING_IN_NEXT_N_DAYS, this.soExpiringInNextNDays);
    }
  }

  deactivateSoExpiring(event?: Event): void {
    if (event) { event.stopPropagation(); }
    this.isSoExpiringActive = false;
    this.broadcastService.broadcast(Constants.SO_EXPIRING_IN_NEXT_N_DAYS, null);
  }

  includeStandingOrdersOnly(): void {
    if (!this.includeStandingOrders) {
      this.includeStandingOrders = true;
      this.emitStandingOrdersOnlyFilter();
    }
  }

  excludeStandingOrdersOnly(event: Event): void {
    event.stopPropagation();
    this.includeStandingOrders = false;
    this.emitStandingOrdersOnlyFilter();
  }

  emitStandingOrdersOnlyFilter(): void {
    this.broadcastService.broadcast(Constants.IS_STANDING_ORDERS_ONLY, this.includeStandingOrders);
  }

  private applyDefaultSort() {
    const sortState: Sort = {
      active: this.config.sortState.active,
      direction: this.config.sortState.direction as SortDirection
    };
    this.sort.active = sortState.active;
    this.sort.direction = sortState.direction;
    this.sort.sortChange.emit(sortState);
  }

  returnBool(isRead) {
    if (isRead === undefined || isRead === null) {
      return "400";
    }
    return isRead ? "400" : "700";
  }
  
  ngOnDestroy(): void {
    if (this.broadcastSubscription) {
      this.broadcastSubscription.unsubscribe();
    }
    if (this.queryParamsSubscription) {
    this.queryParamsSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.KeyPressedStr)) {
      this.KeyPressedStr.unsubscribe();
    }
  }
}
